import { Ability, AbilityBuilder, AbilityClass } from '@casl/ability'
import { IUser } from 'redux/store/user/types'
import {
  ACTIONS,
  SUBJECTS,
  Conditions,
  VendorDetailsAbilityBuilder,
  PossibleAbilities,
  VendorDetailsAbility
} from '../Abilities'
import { ROLES } from '../../Permission'

const VendorAbilityClass = Ability as AbilityClass<VendorDetailsAbility>

export const ability = new Ability<PossibleAbilities, Conditions>()

export default (user: IUser) => {
  const builder = new AbilityBuilder(VendorAbilityClass)

  if (user.role === ROLES.VENDOR_CONTRACT_ADMIN) {
    defineVendorCAAbilities(builder)
  }

  return new Ability(builder.rules) as VendorDetailsAbility
}

const defineVendorCAAbilities = (builder: VendorDetailsAbilityBuilder) => {
  builder.can(ACTIONS.EDIT, SUBJECTS.VENDOR_DETAILS)
}
